<template>
  <div class="footer">
    <div class="row">
      <div
        v-for="item in visibleNavItems"
        :key="item.id"
        class="column"
        :class="{ disabled: item.disabled }"
      >
        <!-- Icono y evento de clic -->
        <div class="row" @click="handleClick(item)">
          <div class="nav_icon" :class="{ selected: item.selected }">
            <img
              :src="item.icon"
              class="custom-icon"
              :class="item.iconClass"
              :alt="item.label"
            />
          </div>
        </div>
        <!-- Etiqueta debajo del icono -->
        <a :class="{ selected: item.selected }">{{ item.label }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomBar",
  props: {
    farmSelected: {
      type: Boolean,
      default: false,
    },
    zoneSelected: {
      type: Boolean,
      default: false,
    },
    isStaff: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      farmType: null, // COMMERCIAL o COOPERATIVE
      productionMode: null, // WEIGHT o COUNT
      // Definición de pestañas del menú inferior
      navItems: [
        {
          id: 1,
          label: "Finca",
          icon: require("@/assets/icon/map.png"),
          iconClass: "icon-map",
          selected: true,
          disabled: false,
        },
        {
          id: 2,
          label: "Unidad de Recolección",
          icon: require("@/assets/icon/field.png"),
          iconClass: "icon-field",
          selected: false,
          disabled: true,
        },
        {
          id: 3,
          label: "Formato",
          icon: require("@/assets/icon/inbox.png"),
          iconClass: "icon-inbox",
          selected: false,
          disabled: true,
        },
        {
          id: 4,
          label: "Cantidad",
          icon: require("@/assets/icon/calculator.png"),
          iconClass: "icon-calculator",
          selected: false,
          disabled: true,
        },
        {
          id: 5,
          label: "Predicción",
          icon: require("@/assets/icon/lightbulb.png"),
          iconClass: "icon-lightbulb",
          selected: false,
          disabled: true,
        },
      ],
    };
  },

  computed: {
    visibleNavItems() {
      const baseItems =
        this.farmType === "COOPERATIVE"
          ? this.navItems.map((item) => {
              if (item.id === 3) {
                return { ...item, label: "Modo/Categoría" };
              }
              return item;
            })
          : this.navItems;

      return baseItems.map((item) => {
        if (item.id === 5) {
          return {
            ...item,
            disabled: !this.isStaff || !this.farmSelected,
          };
        }
        return item;
      });
    },
  },

  mounted() {
    // Guardar referencias para poder eliminarlos en beforeDestroy
    this._onFarmland = (finca) => {
      this.farmType = finca?.farm_type || null;
      this.productionMode = null;
      const hasZones = Array.isArray(finca?.zones) && finca.zones.length > 0;

      if (!hasZones && this.farmType === "COMMERCIAL") {
        this.enableTab(3);
        this.selectTab(3);
        return;
      }

      this.enableTab(2);
      this.selectTab(2);
    };
    this._onZone = () => {
      this.enableTab(3);
      this.selectTab(3);
    };
    this._onProductionMode = (modo) => {
      this.productionMode = modo;
    };
    this._onCategory = () => {
      if (this.productionMode === "COUNT") {
        this.enableTab(4);
        this.selectTab(4);
      }
    };
    this._onFormat = () => {
      this.enableTab(4);
      this.selectTab(4);
    };
    this._onQuantity = () => {
      this.resetTabs();
      this.selectTab(1);
    };

    this.$root.$on("farmland", this._onFarmland);
    this.$root.$on("zone", this._onZone);
    this.$root.$on("production-mode", this._onProductionMode);
    this.$root.$on("category", this._onCategory);
    this.$root.$on("format", this._onFormat);
    this.$root.$on("quantity", this._onQuantity);

    // Sincroniza la pestaña seleccionada con la ruta activa
    this.syncTabWithRoute(this.$route);
    this.$watch("$route", (to) => {
      this.syncTabWithRoute(to);
    });
  },

  beforeDestroy() {
    this.$root.$off("farmland", this._onFarmland);
    this.$root.$off("zone", this._onZone);
    this.$root.$off("production-mode", this._onProductionMode);
    this.$root.$off("category", this._onCategory);
    this.$root.$off("format", this._onFormat);
    this.$root.$off("quantity", this._onQuantity);
  },

  methods: {
    // Sincroniza la pestaña seleccionada con la ruta activa
    syncTabWithRoute(route) {
      const path = route.path;
      let id = 1;
      if (path === "/production") id = 1;
      else if (path === "/production/zones") id = 2;
      else if (path === "/production/formats") id = 3;
      else if (path === "/production/quantity") id = 4;
      else if (path === "/production/prediction") id = 5;
      // Forzar actualización reactiva
      this.navItems = this.navItems.map((item) => ({
        ...item,
        selected: item.id === id,
      }));
    },

    // Habilita una pestaña por ID
    enableTab(id) {
      const item = this.navItems.find((i) => i.id === id);
      if (item) item.disabled = false;
    },

    // Reinicia pestañas: solo Finca queda activa; Predicción depende de finca + staff
    resetTabs() {
      this.farmType = null;
      this.productionMode = null;
      this.navItems.forEach((item) => {
        item.disabled = item.id !== 1;
      });
    },

    // Marca una pestaña como seleccionada y emite evento
    selectTab(id) {
      this.navItems.forEach((item) => {
        item.selected = item.id === id;
      });
      // Navegación usando router
      switch (id) {
        case 1:
          if (this.$route.path !== "/production")
            this.$router.push("/production");
          break;
        case 2:
          if (this.$route.path !== "/production/zones")
            this.$router.push("/production/zones");
          break;
        case 3:
          if (this.$route.path !== "/production/formats")
            this.$router.push("/production/formats");
          break;
        case 4:
          if (this.$route.path !== "/production/quantity")
            this.$router.push("/production/quantity");
          break;
        case 5:
          if (!this.isStaff || !this.farmSelected) return;
          if (this.$route.path !== "/production/prediction")
            this.$router.push("/production/prediction");
          break;
        default:
          if (this.$route.path !== "/production")
            this.$router.push("/production");
      }
      this.$emit("navigate", id === 5 ? 6 : id);
    },

    // Maneja el clic del usuario: permite navegar a cualquier pestaña habilitada
    handleClick(item) {
      if (!item.disabled) {
        this.selectTab(item.id);
      }
    },
  },
};
</script>
